module.exports = __webpack_public_path__ + "img/base_patrimoine_musee.55cb830a.svg";